import React from "react";
import { connect } from "react-redux";
import { Button, ButtonToolbar, Glyphicon, Modal } from "react-bootstrap";

import uuidv4 from "uuid/v4";
import toastr from "toastr";
import { ElementStatus, DataType, Tag, Mode } from "./constant";
import FieldModal from "./field-modal";
import { GetFields, AddField, UpdateField, DeleteField } from "./action";
import { Grid } from "../../Grid";

class AddConfigurationElementModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: Mode.NEW,
      selectedField: {
        id: "",
        fieldDefinitionId: 0,
        fieldName: "",
        recipeFieldName: "",
        dataType: DataType.String,
        tag: Tag.Info,
        parentId: props.parentId,
        arrayIndex: 0,
        sequence: 0,
        includeInRecipe: true,
        readOnly: false,
        value: "",
        displayValue: "",
        isDeleted: false,
        isRequired: false,
        hasChanged: false,
        elementStatus: ElementStatus.NEW,
        path: "configuration",
      },
      showFieldModal: false,
    };

    this.onSaveField = this.onSaveField.bind(this);
    this.closeFieldModal = this.closeFieldModal.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(GetFields());
  }

  closeFieldModal() {
    this.setState({
      ...this.state,
      showFieldModal: false,
    });
  }

  onEdit(row) {
    this.setState({
      showFieldModal: true,
      mode: Mode.EDIT,
      selectedField: row,
    });
  }

  async onDelete(row) {
    let response = await this.props.dispatch(DeleteField(row.id));

    if (response.isSuccess) {
      toastr.info(`Field ${row.field} successfully deleted.`, "Delete");
      this.props.dispatch(GetFields());
    } else {
      toastr.error(`${response.payload.error}`, "Error");
    }
  }

  async onSaveField(field, mode) {
    if (mode === Mode.NEW) {
      const response = await this.props.dispatch(AddField(field));
      if (response.isSuccess) {
        await this.props.dispatch(GetFields());
        toastr.info(`Field ${field.field} successfully saved.`, "Save");
        this.closeFieldModal();
      } else {
        toastr.error(`${response.payload.error}`, "Error");
      }
    } else if (mode === Mode.EDIT) {
      const response = await this.props.dispatch(UpdateField(field));
      if (response.isSuccess) {
        await this.props.dispatch(GetFields());
        toastr.info(`Field ${field.field} successfully updated.`, "Update");
        this.closeFieldModal();
      } else {
        toastr.error(`${response.payload.error}`, "Error");
      }
    }
  }

  onCellClick = async (e, column, columnIndex, row, rowIndex) => {
    if (columnIndex < 4) {
      await this.setState({
        selectedField: {
          id: uuidv4(),
          fieldDefinitionId: row.id,
          fieldName: row.field,
          recipeFieldName: row.recipeField,
          dataType: row.dataTypeKey,
          tag: Tag.Info,
          parentId: this.props.parentId,
          arrayIndex: 0,
          sequence: this.props.sequence + 1,
          includeInRecipe: true,
          readOnly: false,
          value: row.dataTypeKey === DataType.Boolean ? false : "",
          displayValue: "",
          isDeleted: false,
          isRequred: false,
          hasChanged: false,
          elementStatus: ElementStatus.NEW,
          path: this.props.path,
        },
      });

      this.props.onRowClick(this.state.selectedField);
    }
  };

  render() {
    const columns = [
      {
        dataField: "id",
        text: "Id",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "recipeField",
        text: "Recipe Field",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "dataTypeKey",
        text: "Data Type Key",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "field",
        text: "Field",
        sort: true,
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) =>
            this.onCellClick(e, column, columnIndex, row, rowIndex),
        },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "dataTypeValue",
        text: "Type",
        sort: true,
        events: {
          onClick: (e, column, columnIndex, row, rowIndex) =>
            this.onCellClick(e, column, columnIndex, row, rowIndex),
        },
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "buttons",
        text: "",
        headerStyle: () => {
          return { width: "120px" };
        },
        formatter: (cell, row) => (
          <ButtonToolbar>
            <Button
              bsStyle="default"
              title="Edit Field"
              onClick={() => this.onEdit(row)}
            >
              <Glyphicon glyph="edit" />
            </Button>
            <Button
              bsStyle="danger"
              title="Delete Field"
              onClick={() => this.onDelete(row)}
            >
              <Glyphicon glyph="trash" />
            </Button>
          </ButtonToolbar>
        ),
      },
    ];
    const rowStyle = { cursor: "pointer" };

    return (
      <Modal
        show={this.props.show}
        onHide={this.props.onHide}
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Select Field</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            bsStyle="primary"
            bsSize="small"
            id="btnAddNewField"
            onHide={this.closeNewFieldModal}
            onClick={() =>
              this.setState({ showFieldModal: true, mode: Mode.NEW })
            }
          >
            <Glyphicon glyph="plus" /> New Field
          </Button>
          <Grid
            keyField="id"
            columns={columns}
            data={this.props.list}
            rowStyle={rowStyle}
          />
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-grey" onClick={this.props.onHide}>
            Close
          </button>
        </Modal.Footer>
        <FieldModal
          field={this.state.selectedField}
          show={this.state.showFieldModal}
          onHide={this.closeFieldModal}
          mode={this.state.mode}
          onSave={this.onSaveField}
        />
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let currentSelectedFields = ownProps.configurations.filter(function (x) {
    return x.path === ownProps.path && !x.isDeleted;
  });
  let fields = state.configuration.fields.filter(function (x) {
    return (
      (x.dataTypeKey === DataType.String ||
        x.dataTypeKey === DataType.Boolean ||
        x.dataTypeKey === DataType.Integer ||
        x.dataTypeKey === DataType.Date) &&
      currentSelectedFields.findIndex((i) => i.fieldName === x.field) === -1
    );
  });

  return {
    list: fields,
  };
};

export default connect(mapStateToProps)(AddConfigurationElementModal);
